<p-table #dt
    [value]="parties"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    [totalRecords]="totalRecords"
    [loading]="isLoading"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm party-table"
    [tableStyle]="{ 'min-width': '54rem' }"
    [globalFilterFields]="['entityName', 'emailAddress', 'phoneNumber', 'address', 'crNumber']">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Contact</th>
            <th>Identifier</th>
            <th class="text-right">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-party>
        <tr>
            <td>
                <div class="party-identity">
                    <p-avatar [image]="party.imageUrl" [icon]="icon" styleClass="party-avatar" shape="circle"></p-avatar>
                    <div class="min-w-0">
                        <a *ngIf="getViewLink(party) as viewLink; else partyNameOnly"
                            class="party-name party-name-link"
                            [routerLink]="viewLink">
                            {{ party.entityName || 'Unnamed party' }}
                        </a>
                        <ng-template #partyNameOnly>
                            <div class="party-name">{{ party.entityName || 'Unnamed party' }}</div>
                        </ng-template>
                        <div class="party-muted">{{ party.address || party.id?.entityType || 'No address captured' }}</div>
                    </div>
                </div>
            </td>
            <td>
                <div class="party-stack">
                    <span>{{ party.emailAddress || 'No email' }}</span>
                    <span class="party-muted">{{ party.phoneNumber || 'No phone' }}</span>
                </div>
            </td>
            <td>
                <div class="party-stack">
                    <p-tag [value]="party.id?.entityType || 'Party'" severity="info"></p-tag>
                    <span class="party-muted">{{ party.crNumber ? ('CR ' + party.crNumber) : 'No CR number' }}</span>
                </div>
            </td>
            <td class="text-right">
                <a *ngIf="getViewLink(party) as viewLink"
                    pButton
                    icon="pi pi-eye"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    pTooltip="View details"
                    tooltipPosition="left"
                    [routerLink]="viewLink">
                </a>
                <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                    pTooltip="Edit" tooltipPosition="left" (click)="onEdit(party)"></p-button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr><td colspan="4" class="text-center p-4">{{ emptyMessage }}</td></tr>
    </ng-template>
</p-table>
